import LoggedOutRoute from './LoggedOutRoute';

export default LoggedOutRoute;
